const dataImage = [
    //color
    {
        picUrl: '/images/red-pic.jpg'
    },
    {
        picUrl: '/images/blue-pic.jpg'
    },
    {
        picUrl: '/images/green-pic.jpg'
    },
    {
        picUrl: '/images/yellow-pic.jpg'
    },
    {
        picUrl: '/images/purple-pic.jpg'
    },
    {
        picUrl: '/images/black-pic.jpg'
    },
    //tourist
    {
        picUrl: '/images/beach-pic.jpeg'
    },
    {
        picUrl: '/images/city-pic.jpeg'
    },
    {
        picUrl: '/images/mountain-pic.jpeg'
    },
    {
        picUrl: '/images/forest-pic.jpeg'
    },
    {
        picUrl: '/images/history-pic.jpeg'
    },
    {
        picUrl: '/images/art-pic.jpeg'
    },
    //bedroom
    {
        picUrl: '/images/simple-bedroom-pic.jpeg'
    },
    {
        picUrl: '/images/colorfull-bedroom-pic.jpeg'
    },
    {
        picUrl: '/images/woot-bedroom-pic.jpeg'
    },
    {
        picUrl: '/images/vintage-bedroom-pic.jpeg'
    },
    {
        picUrl: '/images/art-bedroom-pic.jpeg'
    },
    {
        picUrl: '/images/simple2-bedroom-pic.jpeg'
    },
    //food
    {
        picUrl: '/images/sea-food-pic.jpeg'
    },
    {
        picUrl: '/images/asia-food-pic.jpeg'
    },
    {
        picUrl: '/images/frence-food-pic.jpeg'
    },
    {
        picUrl: '/images/italian-food-pic.jpeg'
    },
    {
        picUrl: '/images/maxican-food-pic.jpeg'
    },
    {
        picUrl: '/images/china-food-pic.jpeg'
    },
    //house
    {
        picUrl: '/images/modle-home-pic.jpeg'
    },
    {
        picUrl: '/images/classic-home-pic.jpeg'
    },
    {
        picUrl: '/images/countryside-home-pic.jpeg'
    },
    {
        picUrl: '/images/scandivia-home-pic.jpeg'
    },
    {
        picUrl: '/images/minimal-home-pic.jpeg'
    },
    {
        picUrl: '/images/big-home-pic.jpeg'
    },
    //car
    {
        picUrl: '/images/sport-car-pic.jpeg'
    },
    {
        picUrl: '/images/hight-car-pic.jpeg'
    },
    {
        picUrl: '/images/electronic-car-pic.jpeg'
    },
    {
        picUrl: '/images/offroad-car-pic.jpeg'
    },
    {
        picUrl: '/images/middle-car-pic.jpeg'
    },
    {
        picUrl: '/images/van-car-pic.jpeg'
    },
]

export default dataImage;